module.exports = __webpack_public_path__ + "assets/img/warrior-name-2b5ad5f3.png";